import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('BaseObject')
export class BaseObject {
  @JsonProperty('createdAt', String, true) createdAt: string = undefined;
  @JsonProperty('updatedAt', String, true) updatedAt: string = undefined;
}
